import React, { Component } from "react";
import styles from "./NotificationBar.css";
import MenuToggle from "../MenuToggle/MenuToggle";

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const cookieName = "notificationbar";
const cookieClosed = "closed";

class NotificationBar extends Component {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);

    this.state = {
      visible: false,
      closed: false,
    };
  }

  componentDidMount() {
    if (getCookie(cookieName) !== cookieClosed) {
      this.setState({ visible: true });
    }
  }

  onClose() {
    setCookie(cookieName, cookieClosed, 7);
    this.setState({ closed: true });
  }

  render() {
    return (
      <div
        style={{ display: this.state.visible ? "block" : "none" }}
        className={`${styles.wrapper} ${
          this.state.closed ? styles.hidden : ""
        }`}
      >
        <div className={styles.closeAction}>
          <MenuToggle isOpen={true} onMenuToggle={this.onClose} />
        </div>
        <div
          className={styles.contentContainer}
          style={{ opacity: this.state.closed ? 0 : 1 }}
        >
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: this.props.message }}
          />
        </div>
      </div>
    );
  }
}

export default NotificationBar;



// WEBPACK FOOTER //
// ./src/components/NotificationBar/NotificationBar.js